import React, { Component, Fragment } from 'react';
import MetisMenu from 'react-metismenu';
import MainNavComponent from './NavItems';
import Storage from '../../services/Storage';
import { getUserInfo } from '../../constants/apiCalls';
import ModalService from '../../services/ModalService';
import { handleErrorMessage } from '../../utils/utils';
import { connect } from 'react-redux';
import {getPermissionUser, getUserInfoDetail} from '../../reducers/UserGetReducer';

class Nav extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // permissionsState: Storage.getUserPermissionDetail()
      permissionsState: props.arrPermissionState,
      userState : props.userInfoDetailState,
    };
    let token = Storage.getTokenDetail();
    if (token.accessToken) {
      this.getUserDetails();
    }
  }

  getUserDetails() {
    getUserInfo((res) => {
      const { data, success, error } = res;
      if (success === true) {
        this.props.getPermissionUser(data.permissions);
        this.setState({ permissionsState: this.props.arrPermissionState })

        this.props.getUserInfoDetail(data);
        this.setState({ userState: this.props.userInfoDetailState })

      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
    });
  }

  onMenuSelected = (data) => {
    let token = Storage.getTokenDetail();
    if (token.accessToken) {
      this.getUserDetails();
    }
    // Set Empty Array
    if (data) {
      // Table Page
      Storage.removeOpenMeetingPage();
      Storage.removeMeetingHistoryPage();
      Storage.removePipelinePage();
      Storage.removeAppprovePage();
      Storage.removeRejectPage();
      Storage.removeOrderPage();
      Storage.removeBirthdayPage();
      Storage.removeMAnniversaryPage();
      Storage.removeWorkAnniversaryPage();
      Storage.removeDealerListPage();

      Storage.removeAssignDealerCodePage();
      Storage.removeManageUserPage();
      Storage.removeManageDealerPage();
      Storage.removeProductListPage();
      Storage.removeManageTerritoryPage();
      Storage.removeDistanceTravelPage();

      Storage.removeBreadcrumbsrRecord();
    }
  };

  render() {
    const MainNav = MainNavComponent.getMenus();
    return (
      <Fragment>
        <MetisMenu
          content={MainNav}
          activeLinkFromLocation
          className='vertical-nav-menu'
          iconNamePrefix=''
          classNameStateIcon='pe-7s-angle-down'
          onSelected={(e) => this.onMenuSelected(e)}
        />
      </Fragment>
    );
  }
  // componentDidMount(){
  // this.onMenuSelected()
  // }
  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }
}

const mapStateToProp = (state) => ({
  arrPermissionState: state.UserGetReducer.permissionArr,
  userInfoDetailState: state.UserGetReducer.userInfoDetail,
});

// export default withRouter(connect(mapStateToProp, { getPermissionUser, getUserInfoDetail })(Nav));
export default connect(mapStateToProp, { getPermissionUser, getUserInfoDetail })(Nav);
